import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import axios from "./axios";
import store from "./store";

Vue.use(Router);

// lazy-loaded
function loadView(view) {
	return () =>
		import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`);
}

const routerMode = process.env.NODE_ENV == "development" ? "hash" : "history";

const router = new Router({
	mode: "history",
	routes: [
		{
			path: "/",
			name: "home",
			component: Home
		},
		{
			path: "/terms_of_service",
			name: "terms_of_service",
			component: loadView("Terms_of_service")
		},
		{
			path: "/privacy_policy",
			name: "privacy_policy",
			component: loadView("Privacy_policy")
		},
		{
			path: "/money_settlement",
			name: "money_settlement",
			component: loadView("Money_settlement")
		},
		{
			path: "/specific_business",
			name: "specific_business",
			component: loadView("Specific_business")
		},
		{
			path: "/pre_registration",
			name: "pre_registration",
			component: loadView("pre_registration")
		},
		{
			path: "/login_status",
			name: "login_status",
			component: loadView("login_status")
		},
		{
			path: "/feedback",
			name: "feedback",
			component: loadView("feedback")
		},
	]
});

router.beforeEach(async (to, from, next) => {
	next();
});

export default router;
